<template>
  <div class="sturep">
    <!-- <bannerof
      v-if="navlist !== null && navlist.length > 0"
      style="color: #ffffff"
      :Imgsrc="childrendata[0].bannerUrl"
    ></bannerof> -->
    <secondary-banner title="学业评价报告"></secondary-banner>
    <div class="sturep_warp secondary_page_bg">
      <div class="sturep_centers">
        <div class="sturep_left">
          <div class="stureoleft_top1">
            <span
              class="cj_btns"
              :class="selindex == 0 ? 'selbor' : ''"
              @click="selshowbtn(0)"
              >个人综合成绩</span
            >
            <span
              class="cj_btns cjbtn2"
              :class="selindex == 1 ? 'selbor' : ''"
              @click="selshowbtn(1)"
              >个人成绩详情</span
            >
          </div>
          <!-- 折线图 -->
          <div class="linex_all" v-if="selindex == 0">
            <el-empty description="空空如也" v-if="lineanlist.length == 0"></el-empty>
            <ring-chart
              v-else
              :pie-data="pieData"
              width="100%"
              height="100%"
            ></ring-chart>
            <p v-if="lineanlist.length > 0" class="banjmc">班级名次</p>
          </div>
          <div class="linex_table">
            <el-table
              :data="lineanlist"
              border
              style="width: 100%"
              :cell-style="cellStyle"
              stripe
              :header-cell-style="{
                fontSize: '16px',
                color: '#666666',
                fontWeight: 'bold',
              }"
            >
              <el-table-column
                label="序号"
                width="80"
                align="center"
                type="index"
                :index="indexMethod"
              />
              <el-table-column prop="semesterName" align="center" label="学年学期">
              </el-table-column>
              <el-table-column prop="avgScore" label="综合平均分" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.avgScore }}分</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="classRanking" label="班级名次">
              </el-table-column>
            </el-table>
          </div>
          <!-- 学生个人综合成绩 -->
          <div class="stu_achievement">
            <div class="stu_listement" v-for="(item, index) in achtableData" :key="index">
              <div class="stu_Info">
                <span>{{ item.courseAchievementList[0].semesterName }}</span>
                <span class="stu_zhuanye">{{
                  item.courseAchievementList[0].curriculumName
                }}</span>
                <span class="stu_zhuanye">{{
                  item.courseAchievementList[0].className
                }}</span>
              </div>
              <div class="stu_achitable" v-show="selindex == 0">
                <h4>个人综合成绩表：</h4>
                <div class="table_All">
                  <div class="table_s">
                    <el-table
                      :data="item.courseAchievementList"
                      border
                      style="width: 100%"
                      :cell-style="cellStyle"
                      stripe
                      :header-cell-style="{
                        fontSize: '16px',
                        color: '#666666',
                        fontWeight: 'bold',
                      }"
                    >
                      <el-table-column
                        label="序号"
                        width="80"
                        align="center"
                        type="index"
                        :index="indexMethod"
                      />
                      <el-table-column prop="curriculumName" align="center" label="课程">
                        <template slot-scope="scope">
                          <el-tooltip
                            :content="scope.row.curriculumName"
                            placement="top"
                            effect="light"
                          >
                            <span class="kcop2">{{ scope.row.curriculumName }}</span>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="totalQuanzhongScore"
                        label="个人综合成绩"
                      >
                        <template slot-scope="scope">
                          <span class="kcop2">{{ scope.row.totalQuanzhongScore }}分</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
                <h4>班级名次：</h4>
                <div class="xypj_mys">
                  <p>
                    你在本学期的个人综合成绩排名在第
                    <span
                      v-if="lineanlist.length > 0 && lineanlist[index]"
                      class="xypjspcolor"
                      >{{ lineanlist[index].classRanking }}</span
                    >
                    <span class="xypjspcolor" v-else>暂无</span>
                    名,超过
                    <span
                      v-if="lineanlist.length > 0 && lineanlist[index]"
                      class="xypjspcolor"
                      >{{
                        lineanlist[index].classRanking > 0
                          ? item.clazzCount - lineanlist[index].classRanking
                          : 0
                      }}</span
                    >
                    <span class="xypjspcolor" v-else>暂无</span>
                    人,比上学期
                    <span
                      v-if="
                        lineanlist[index + 1] &&
                        lineanlist[index].classRanking -
                          lineanlist[index + 1].classRanking <
                          0
                      "
                      class="xypjspcolor"
                      >前进
                      {{
                        (lineanlist[index].classRanking -
                          lineanlist[index + 1].classRanking) *
                        -1
                      }}
                    </span>
                    <span
                      v-else-if="
                        lineanlist[index + 1] &&
                        lineanlist[index].classRanking -
                          lineanlist[index + 1].classRanking >
                          0
                      "
                      class="xypjspcolor"
                      >后退
                      {{
                        lineanlist[index].classRanking -
                        lineanlist[index + 1].classRanking
                      }}</span
                    >
                    <span
                      v-else-if="
                        lineanlist[index + 1] &&
                        lineanlist[index].classRanking -
                          lineanlist[index + 1].classRanking ==
                          0
                      "
                      class="xypjspcolor"
                    ></span>
                    <span v-else class="xypjspcolor">暂无 </span>
                    名。
                  </p>
                  <p>
                    在80分及以上的课程为：
                    <span
                      v-if="item.achievementCurriculumCountDTO.excellent.length == 0"
                      class="xypjspcolor"
                      >暂无</span
                    >
                    <span
                      v-else
                      v-for="(itemcj, indexcj) in item.achievementCurriculumCountDTO
                        .excellent"
                      :key="indexcj"
                      class="xypjspcolor"
                      >{{ itemcj }}</span
                    >
                  </p>
                  <p>
                    在60-80分(不包括80分)的课程为：
                    <span
                      v-if="item.achievementCurriculumCountDTO.good.length == 0"
                      class="xypjspcolor"
                      >暂无</span
                    >
                    <span
                      v-else
                      v-for="(itemcj, indexcj) in item.achievementCurriculumCountDTO.good"
                      :key="indexcj"
                      class="xypjspcolor"
                      >{{ itemcj }}</span
                    >
                  </p>
                  <p>
                    在60分以下的课程为：
                    <span
                      v-if="item.achievementCurriculumCountDTO.pass.length == 0"
                      class="xypjspcolor"
                      >暂无</span
                    >
                    <span
                      v-else
                      v-for="(itemcj, indexcj) in item.achievementCurriculumCountDTO.pass"
                      :key="indexcj"
                      class="xypjspcolor"
                      >{{ itemcj }}</span
                    >
                  </p>
                  <p>
                    希望你在接下来的学习中 保持当前状态，<span class="xypjspcolor"
                      >再接再厉争创更大进步 / 积极主动参与，提升专业知识和个人能力</span
                    >
                  </p>
                </div>
              </div>
              <el-divider content-position="left"></el-divider>
              <div class="stu_achitable stu_achitable2" v-show="selindex == 1">
                <el-table
                  v-loading="loading"
                  :data="item.courseAchievementList"
                  border
                  style="height: 100%"
                  :header-cell-style="{
                    fontSize: '14px',
                    color: '#666666',
                    fontWeight: 'bold',
                  }"
                >
                  <el-table-column
                    label="序号"
                    width="80"
                    align="center"
                    type="index"
                    :index="indexMethod"
                    fixed
                  />
                  <el-table-column
                    width="280"
                    label="课程"
                    align="center"
                    prop="curriculumName"
                    fixed
                  />

                  <el-table-column
                    label="考勤权重"
                    align="center"
                    prop="kaoqinQuanzhongScore"
                    width="110"
                  />
                  <el-table-column
                    label="作业权重"
                    align="center"
                    prop="zuoyeQuanzhongScore"
                    width="110"
                  />
                  <el-table-column
                    label="讨论权重"
                    align="center"
                    prop="taolunQuanzhongScore"
                    width="110"
                  />
                  <el-table-column
                    label="章节测验权重"
                    align="center"
                    prop="ceyanQuanzhongScore"
                    width="110"
                  />
                  <el-table-column
                    label="任务点权重"
                    align="center"
                    prop="renwuQuanzhongScore"
                    width="110"
                  />
                  <el-table-column
                    label="考试权重"
                    align="center"
                    prop="kaoshiQuanzhongScore"
                    width="110"
                  />
                  <el-table-column
                    label="日常考核权重"
                    align="center"
                    prop="richangQuanzhongScore"
                    width="110"
                  />
                  <el-table-column
                    label="个人综合成绩"
                    align="center"
                    prop="totalQuanzhongScore"
                    width="110"
                    fixed="right"
                  />
                </el-table>
              </div>
            </div>
          </div>
        </div>
        <div class="sturep_right">
          <div class="elva_rigtit">
            <p class="rig_qiu"></p>
            <h3>班级名次</h3>
          </div>
          <!-- 成绩列表 -->
          <div class="cjlistall">
            <div class="cjlistItem">
              <el-tooltip content="Bottom center" placement="top" effect="light">
                <div v-if="classDataAll == null"></div>
                <div v-else-if="classDataAll.length == 0"></div>
                <p class="Item_tit" v-else>
                  {{ classDataAll[0].semesterName }}
                </p>
              </el-tooltip>
              <div class="student_scoll">
                <div v-if="classDataAll == null"></div>
                <div v-else-if="classDataAll.length == 0"></div>
                <el-scrollbar v-else style="height: 100%">
                  <div
                    class="classStu_list"
                    v-for="(item, index) in classDataAll"
                    :key="index"
                  >
                    <el-image :src="item.avatar" class="elimg">
                      <div slot="error" class="image-slot">
                        <img :src="avatardefauter" alt="" />
                      </div>
                    </el-image>
                    <div class="stuname">
                      <p class="stunm1">{{ index + 1 }}. {{ item.stuName }}</p>
                      <p class="scorems">
                        个人综合成绩总分：{{ item.courseTotalScore }}分
                      </p>
                    </div>
                  </div>
                </el-scrollbar>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bannerof from "@/components/bannerof";
import { LineChartAndList, classList, getTraineeList } from "@/api/stureport";
import RingChart from "@/components/ItemEcharts/RingChart";
import SecondaryBanner from "@/components/SecondaryBanner";
export default {
  name: "stureport",
  data() {
    return {
      navId: null,
      childtype: null,
      navlist: null,
      childrendata: null,
      bannerData: {
        title: "",
        subtit: "",
      },
      classDataAll: null,
      selindex: 0,
      pieData: {
        legend: {
          data: ["综合平均分", "班级名次"],
        },
        color: ["#5B9BD5", "#EC7A2B"],
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: [],
          scale: true,
          axisLabel: {
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;
              var provideNumber = 9; //一行显示几个字
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";
                  var start = p * provideNumber;
                  var end = start + provideNumber;
                  if (p == rowNumber - 1) {
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            },
          },
        },
        yAxis: [
          {
            name: "综合平均分",
            type: "value",
            min: 0,
            splitNumber: 5,
          },
          {
            type: "value",
            name: "",
            min: 1,
            splitNumber: 5,
            inverse: true,
            splitLine: false,
          },
        ],
        series: [
          {
            name: "综合平均分",
            data: [],
            type: "bar",
            yAxisIndex: 0,
            barWidth: 45,
            splitLine: {
              show: false,
            },
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top",
                  fontSize: "14",
                },
              },
            },
          },
          {
            name: "班级名次",
            type: "line",
            yAxisIndex: 1,
            data: [],
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  fontSize: "15",
                  color: "#FFA500",
                },
              },
            },
            lineStyle: {
              normal: {
                width: 3,
              },
            },
          },
        ],
      },
      lineanlist: [],
      getTraineeList: [],
      achtableData: [],
      loading: false,
      avatardefauter: require("@/assets/images/avatardefauter.png"),
    };
  },
  components: {
    bannerof,
    RingChart,
    SecondaryBanner,
  },
  watch: {
    "$store.state.user.navbarList": {
      deep: true, //深度监听
      handler(newValue, oldValue) {
        if (newValue.length > 0) {
          console.log("1");
          this.$nextTick(() => {
            this.navforEcher();
          });
        }
      },
    },
    // "$store.state.user.tabindex": {
    //   deep: true, //深度监听
    //   handler(newValue, oldValue) {
    //     if (typeof newValue == "string") {
    //       this.navId = Number(newValue);
    //       if (this.$route.query.childtype) {
    //         this.childtype = this.$route.query.childtype;
    //       } else {
    //         this.childtype = null;
    //       }
    //       this.$nextTick(() => {
    //         console.log("2")
    //         this.navforEcher();
    //       });
    //     }
    //   },
    // },
    // "$store.state.user.ziId": {
    //   deep: true, //深度监听
    //   handler(newValue, oldValue) {
    //     if (typeof newValue == "string") {

    //       this.childtype = newValue;
    //       this.$nextTick(() => {
    //         console.log("3")
    //         this.navforEcher();
    //       });
    //     }
    //   },
    // },
    "$route.query": {
      deep: true, //深度监听
      handler(newValue, oldValue) {
        if (!newValue.childtype) {
          this.childtype = null;
        } else {
          this.childtype = newValue.childtype;
        }

        this.$nextTick(() => {
          console.log("4");
          this.navforEcher();
        });
      },
    },
  },
  created() {
    this.navId = this.$route.query.navId;
    if (this.$route.query.childtype) {
      this.childtype = this.$route.query.childtype;
    } else {
      this.childtype = null;
    }
    this.getleftData();
  },
  mounted() {
    this.$nextTick(() => {
      this.navforEcher();

      this.classdatas();
      this.getTriecj();
    });
  },
  methods: {
    navforEcher() {
      var navlistall = JSON.parse(JSON.stringify(this.$store.state.user.navbarList));
      //筛选出来当前tab栏
      this.navlist = navlistall.filter((el) => {
        return this.navId == el.id;
      });
      if (navlistall.length > 0) {
        //给tab底部高亮
        this.$store.commit("user/SET_TABINDEX", this.childtype);
        if (this.childtype !== null) {
          this.childrendata = this.navlist[0].children.filter((el) => {
            return this.childtype == el.id;
          });
        }
      }
    },
    // 折线图
    getleftData() {
      let query = {
        traineeId: this.$store.getters.userId,
      };
      LineChartAndList(query).then((res) => {
        if (res.code == 200) {
          this.lineanlist = res.data;
          // this.lineanlist = [
          //   {
          //     semesterId: 1,
          //     semesterName: "2021~2022 春季学期",
          //     classId: null,
          //     classRanking: 12,
          //     avgScore: 60.5,
          //   },
          //   {
          //     semesterId: 1,
          //     semesterName: "2021~2022 春季学期",
          //     classId: null,
          //     classRanking: 12,
          //     avgScore: 80.6,
          //   },
          //   {
          //     semesterId: 1,
          //     semesterName: "2021~2022 春季学期",
          //     classId: null,
          //     classRanking: 10,
          //     avgScore: 59.2,
          //   },
          //   {
          //     semesterId: 1,
          //     semesterName: "2021~2022 春季学期",
          //     classId: null,
          //     classRanking: 11,
          //     avgScore: 67.15,
          //   },
          //   {
          //     semesterId: 1,
          //     semesterName: "2021~2022 春季学期",
          //     classId: null,
          //     classRanking: 5,
          //     avgScore: 55.7,
          //   },
          //   {
          //     semesterId: 1,
          //     semesterName: "2021~2022 春季学期",
          //     classId: null,
          //     classRanking: 19,
          //     avgScore: 21.4,
          //   },
          // ];

          // 折线图
          let xarr = [];
          let arr1 = [];
          let arr2 = [];
          let YLeftMax = 0;
          let yRightMax = 0;
          if (this.lineanlist.length > 0) {
            for (let index = 0; index < this.lineanlist.length; index++) {
              xarr.push(this.lineanlist[index].semesterName);
              arr1.push(Number(this.lineanlist[index].avgScore));
              arr2.push(Number(this.lineanlist[index].classRanking));
            }

            YLeftMax = Math.ceil(Math.ceil(Math.max(...arr1)) / 5) * 5;
            yRightMax = Math.ceil(Math.ceil(Math.max(...arr2)) / 5) * 5;
          }
          this.pieData.xAxis.data = xarr;
          this.pieData.series[0].data = arr1;
          this.pieData.series[1].data = arr2;
          this.pieData.yAxis[0].max = YLeftMax;
          this.pieData.yAxis[0].interval = Math.ceil(Math.ceil(Math.max(...arr1)) / 5);
          this.pieData.yAxis[1].max = yRightMax;
          this.pieData.yAxis[1].interval = Math.ceil(Math.ceil(Math.max(...arr2)) / 5);
        }
      });
    },
    //个人综合成绩
    getTriecj() {
      let query = {
        traineeId: this.$store.getters.userId,
      };
      this.loading = true;
      getTraineeList(query).then((res) => {
        if (res.code == 200) {
          this.achtableData = res.data;
          // this.achtableData = [
          //   {
          //     courseAchievementList: [
          //       {
          //         semesterName: "2021~2022 春季学期",
          //         curriculumName: "园林工程技术专业",
          //         className: "园林工程技术专业101",
          //         id: 1,
          //         totalQuanzhongScore: 25.6,
          //         kaoqinQuanzhongScore: 5.5,
          //         zuoyeQuanzhongScore: 15,
          //         taolunQuanzhongScore: 18,
          //         ceyanQuanzhongScore: 22,
          //       },
          //     ],
          //     clazzCount: 15,
          //     achievementCurriculumCountDTO: {
          //       excellent: [],
          //       good: [],
          //       pass: [],
          //     },
          //   },
          // ];
        }
        this.loading = false;
      });
    },
    //序号
    indexMethod(index) {
      return index + 1;
    },

    //班级排名
    classdatas() {
      let query = {
        traineeId: this.$store.getters.userId,
      };
      classList(query).then((res) => {
        if (res.code == 200) {
          this.classDataAll = res.data;
          // this.classDataAll = [
          //   {
          //     semesterName: "2021~2022 春季学期",
          //     avatar: null,
          //     stuName: "程前明",
          //     courseTotalScore: 60.5,
          //   },
          //   {
          //     semesterName: "2021~2022 春季学期",
          //     avatar: null,
          //     stuName: "程前明",
          //     courseTotalScore: 60.5,
          //   },
          // ];
        }
      });
    },
    selshowbtn(index) {
      this.selindex = index;
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex % 2 == 1) {
        return "background:#F6F5FB";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.sturep {
  .sturep_warp {
    width: 100%;

    overflow: hidden;

    .sturep_centers {
      width: 1400px;
      min-height: 1050px;
      margin: 0 auto;
      margin-top: 50px;
      margin-bottom: 35px;
      overflow: hidden;

      .sturep_left {
        width: 1000px;
        min-height: 1030px;
        padding: 15px 50px;
        float: left;
        background-color: #fff;
        .stureoleft_top1 {
          display: flex;
          .cj_btns {
            display: inline-block;
            text-align: center;
            margin: 0 0 10px 0;
            height: 40px;
            line-height: 40px;
            cursor: pointer;
            font-size: 18px;
            color: #555555;
            font-weight: bold;
          }
          .cjbtn2 {
            margin-left: 100px;
          }
          .selbor {
            color: #1d4434;
            font-weight: bold;
            border-bottom: 2px solid #1d4434;
          }
        }
        // 折线图
        .linex_all {
          width: 123%;
          height: 500px;
          margin-left: -95px;
          margin-top: 30px;
          position: relative;

          .banjmc {
            font-size: 13px;
            position: absolute;
            right: 9%;
            top: 6%;
          }
        }
        // 学生个人综合成绩
        .stu_achievement {
          .stu_listement {
            margin-top: 40px;
          }
          .stu_Info {
            font-size: 16px;
            color: #555555;
            font-weight: bold;

            .stu_zhuanye {
              padding: 0 30px;
            }
          }
          .stu_achitable2 {
            width: 100%;

            margin: 20px 0;
          }
          .stu_achitable {
            overflow: hidden;
            h4 {
              font-size: 16px;
              margin: 18px 0 10px 0;
              color: #555555;
              font-weight: bold;
            }
            .table_All {
              .table_s {
                display: flex;
                flex-wrap: wrap;

                .zhcj_ops {
                  background-color: #f6f5fb;
                }
                .kcop2 {
                  display: inline-block;
                  max-width: 300px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  font-size: 15px;
                }
              }
            }
            // 班级名次
            .xypj_mys {
              font-size: 15px;
              p {
                margin-top: 15px;
                color: #555555;
                .xypjspcolor {
                  display: inline-block;
                  min-width: 40px;
                  text-align: center;
                  color: #B18227;
                  border-bottom: 1px solid #555555;
                  margin: 0 5px;
                }
              }
            }
          }
        }
      }
      .sturep_right {
        width: 360px;
        height: 1030px;
        float: right;
        padding: 15px 30px;
        background-color: #fff;
        overflow: hidden;
        .elva_rigtit {
          display: flex;
          .rig_qiu {
            width: 15px;
            height: 15px;
            border: 2px solid #555555;
            border-radius: 50%;
            margin-top: 5px;
          }
          h3 {
            font-size: 18px;
            margin-left: 10px;
            color: #555555;
            font-weight: bold;
          }
        }
        .cjlistall {
          margin-top: 20px;
          .cjlistItem {
            overflow: hidden;
            .Item_tit {
              color: #555555;
              font-size: 16px;
              font-weight: bold;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .student_scoll {
              width: 100%;
              height: 925px;
              ::v-deep .el-scrollbar__wrap {
                overflow-x: hidden;
              }
              .classStu_list {
                display: flex;
                margin-top: 20px;
                .elimg {
                  width: 60px;
                  height: 60px;
                  border-radius: 50%;
                  border: 1px solid #eeeeee;
                  text-align: center;
                  line-height: 60px;
                  .image-slot {
                    img {
                      width: 60px;
                      height: 60px;
                    }
                  }
                }
                .stuname {
                  color: #555555;
                  padding: 0 0 0 15px;
                  line-height: 30px;
                  .stunm1 {
                    max-width: 230px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-weight: bold;
                    font-size: 15px;
                  }
                  .scorems {
                    font-size: 15px;
                    font-weight: 500;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
